import CatResultProvider from "./CatResultProvider";
import CatResultContext from "./context";
import useCatResult from "./useCatResult";

export default CatResultContext;

export { CatResultProvider, useCatResult };
